export default __webpack_public_path__ + "static/SONY_IMX335_Day-97ff2473d207125dfb4d385410e8b781.webp";